// docs/63 RF4: the puzzle card's pieces under the fog of closed doors. The card lists the lock's
// pieces as the board labels them (`puzzle_room.pieces`); behind a door the party has never seen
// past, those fixtures are not in its view, so the card names only the ones it has seen.

/**
 * The pieces whose fixture is in the party's view: named as the card's line is (a statue, a dial),
 * or by the line's first part (a rune, a bell or a lever is named by its piece alone). With
 * `fixtureNames` undefined (no fog of closed doors), every piece.
 */
export function seenPieces(pieces: readonly string[], fixtureNames: readonly string[] | undefined): string[] {
  if (!fixtureNames) return [...pieces];
  const names = new Set(fixtureNames);
  return pieces.filter((p) => names.has(p) || names.has(p.split(' — ')[0]!));
}
